import React, { useEffect, useState } from 'react';
import './Projects.css';
// import doctorsPortal from '../../images/projectImage/doctorsPortal.JPG';
// import emaJohn from '../../images/projectImage/emaJohn.JPG';
// import hotOnion from '../../images/projectImage/hotOnion.JPG';
// import hotGadgets from '../../images/projectImage/hotGadgets.JPG';
// import pandaCommerce from '../../images/projectImage/pandaCommerce.JPG';
import Project from './Project';

import globalLeaf from '../../images/industrial-project/Global Leaf (GLTC).png';
import bastu from '../../images/industrial-project/bastu.png';
import minimaleast from '../../images/industrial-project/minimaleast.png';
import fcfs from '../../images/industrial-project/First Choice Family Service.png';
import toyotaAltis from '../../images/industrial-project/Toyota Altis.png';
import toyotaYaris from '../../images/industrial-project/toyota-yaris.png';
import toyotaServiceCenter1 from '../../images/industrial-project/Toyota Service Center 1.png';
import toyotaServiceCenter2 from '../../images/industrial-project/Toyota Service Center 2.png';
import titasAgro from '../../images/industrial-project/titas agro.png';
import greenGateway from '../../images/industrial-project/Green Gateway Unilever Email Template.png';
import fallFest from '../../images/industrial-project/Fall Fest 21 Unilever Email Template.png';
import shuttleMonthly from '../../images/industrial-project/Shuttle Monthly newsletter email teplate.png';
import bastu2 from '../../images/industrial-project/Bastu2-min.png';
import bhorerKagoj from '../../images/industrial-project/Bhorer Kagoj-min.png';
import bsaa from '../../images/industrial-project/BSAA-min.png';
import cilt from '../../images/industrial-project/CILT-min.png';
import emraldRestaurent from '../../images/industrial-project/Emerald Restaurent-min.png';
import khoj from '../../images/industrial-project/Khoj-min.png';
import marshMaylo from '../../images/industrial-project/Marshmaylo-min.png';
import iPractUs from '../../images/industrial-project/IPractUs.png'

const Projects = () => {

    const [allProjects, setAllProjects] = useState([]);

    // const [practiceProject] = useState(
    //     [
    //         {
    //             id: '01', img: "" + doctorsPortal, title: "Doctors Portal", description: "A fullstack doctors portal website.",
    //             gitHub: "https://github.com/shakil1206/doctors-portal", liveLink: "https://doctorsportal-b406a.web.app/"
    //         },

    //         {
    //             id: '02', img: "" + hotOnion, title: "Hot Onion Restaurant", description: "A fullstack hot onion restaurant website.",
    //             gitHub: "https://github.com/shakil1206/hot-onion-restaurent", liveLink: "https://hot-onion-resturent.firebaseapp.com/"
    //         },

    //         {
    //             id: '03', img: "" + emaJohn, title: "Ema-John", description: "A fullstack Ema-John e-commerce website.",
    //             gitHub: "https://github.com/shakil1206/ema-john-simple", liveLink: "https://nifty-dijkstra-258270.netlify.app/"
    //         },

    //         {
    //             id: '04', img: "" + hotGadgets, title: "Hot Gatgets", description: "A front-end E-commerce website.",
    //             gitHub: "https://github.com/shakil1206/hot-gadgets", liveLink: "https://shakil1206.github.io/hot-gadgets/"
    //         },

    //         {
    //             id: '05', img: "" + pandaCommerce, title: "Panda Commerce", description: "A front-end Panda Commerce website.",
    //             gitHub: "https://github.com/shakil1206/panda-commerce1", liveLink: "https://shakil1206.github.io/panda-commerce1/"
    //         }
    //     ]
    // );

    const [industrialProject] = useState([
        {
            id: '20', img: "" + iPractUs, title: "IPrActUS", description: "This is a very big project. So, in this project, we developed it with many developers. In this project, my role was React Frontend Developer. And here I have developed many more features like Go-Live, Public & Private Profile development, Library creation, Payment method, Newsfeed, & so on by using react, redux & many more technologies.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://github.com/shakil1206"
        },
        {
            id: '01', img: "" + bastu2, title: "Bastu", description: "Bastu property buy/sell/rental website. Which I have design & development by using Javascript, Google Map, Bootstrap, Jquery, Laravel and many more.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://bastu-new-ui.netlify.app/"
        },
        {
            id: '02', img: "" + bhorerKagoj, title: "Bhorer Kagoj E-Commerce Website", description: "Bhorer Kagoj e-commerce website. Which I have design & development by using Javascript, Jquery, Bootstrap, Laravel and many more.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://bhorer-kagoj-new.netlify.app/"
        },
        {
            id: '03', img: "" + bsaa, title: "Bangladesh Shipping Agents Association (BSAA) ", description: "Bangladesh Shipping Agents Association (BSAA). Which I have design & development by using Javascript, Jquery, Bootstrap, Laravel and many more. ",
            gitHub: "https://github.com/shakil1206", liveLink: "https://bsaa.netlify.app/"
        },
        {
            id: '04', img: "" + cilt, title: "The Chartered Institute of Logistics & Transport", description: "The Chartered Institute of Logistics & Transport. Which I have design & development by using Javascript, Jquery, Bootstrap, Laravel and many more.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://cilt.netlify.app/"
        },
        {
            id: '05', img: "" + emraldRestaurent, title: "Emerald restaurants", description: "Emerald restaurants website.  Which I have design & development by using Javascript, Jquery, Bootstrap, Laravel and many more.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://emerald-frontend.netlify.app/"
        },
        {
            id: '06', img: "" + khoj, title: "Khoj find your desire service", description: "Khoj find your desire service. Which I have design & development by using Javascript, Jquery, Bootstrap, Laravel and many more.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://khoj.netlify.app/"
        },
        {
            id: '07', img: "" + marshMaylo, title: "Marshmaylo Kids E-Commers Website.", description: "Marshmaylo Kids E-Commers Website. Which I have design & development by using Javascript, Jquery, Bootstrap, Laravel and many more.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://marshmaylo.netlify.app/"
        },
        {
            id: '08', img: "" + globalLeaf, title: "Global Leaf Tobacco Company Ltd. (GLTC)", description: "A Company Branding Website Design and Development.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://global-leaf-frontend.netlify.app"
        },
        {
            id: '09', img: "" + bastu, title: "Bastu", description: "Bastu Website Design and Development with Google Map",
            gitHub: "https://github.com/shakil1206", liveLink: "https://bastu.netlify.app/"
        },
        {
            id: '10', img: "" + minimaleast, title: "Minimaleast", description: "A E-Commerce website build using React",
            gitHub: "https://github.com/shakil1206", liveLink: "https://minimaleast.netlify.app/"
        },
        {
            id: '11', img: "" + fcfs, title: "First Choise Family Service", description: "A Branding Website design and Development (USA)",
            gitHub: "https://github.com/shakil1206", liveLink: "https://first-choice-family-service.netlify.app/"
        },
        {
            id: '12', img: "" + toyotaAltis, title: "Toyota Altis", description: "Toyota Altis Car Models Microsite Design",
            gitHub: "https://github.com/shakil1206", liveLink: "https://toyota-altis.netlify.app/"
        },
        {
            id: '13', img: "" + toyotaYaris, title: "Toyota Yaris", description: "Toyota Yaris Car Models Microsite Design",
            gitHub: "https://github.com/shakil1206", liveLink: "https://toyota-yaris.netlify.app/"
        },
        {
            id: '14', img: "" + toyotaServiceCenter1, title: "Toyota Service Center", description: "Toyota online car service center 1 microsite design.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://toyota-service-center.netlify.app/"
        },
        {
            id: '15', img: "" + toyotaServiceCenter2, title: "Toyota Service Center 2", description: "Toyota online car service center 2 microsite design.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://toyota-service-center2.netlify.app/"
        },
        {
            id: '16', img: "" + titasAgro, title: "Titas Agro", description: "Titas Foods & Agro Products website Design and Development.",
            gitHub: "https://github.com/shakil1206", liveLink: "https://titas-agro.netlify.app/"
        },
        {
            id: '17', img: "" + greenGateway, title: "A Green Gateway (Unilever)", description: "Email Template Design for Unilever",
            gitHub: "https://github.com/shakil1206", liveLink: "https://green-gateway-uniliver.netlify.app/"
        },
        {
            id: '18', img: "" + fallFest, title: "Fall Fest 21 (Unilever)", description: "Email Template Design for Unilever",
            gitHub: "https://github.com/shakil1206", liveLink: "https://fall-fest21-uniliver.netlify.app/"
        },
        {
            id: '19', img: "" + shuttleMonthly, title: "Shuttle Monthly Newsleter", description: "Email Template Design",
            gitHub: "https://github.com/shakil1206", liveLink: "https://shuttle-monthly-newsletter.netlify.app/"
        },
    ])



    // const [menuToggle, setMenuToggle] = useState({ industrial: true, practice: false });


    useEffect(() => {
        setAllProjects(industrialProject);
        // setMenuToggle({ industrial: true, practice: false })
    }, [industrialProject])


    // const industrialAction = () => {
    //     setAllProjects(industrialProject);
    //     setMenuToggle({ industrial: true, practice: false })
    // }

    // const practiceAction = () => {
    //     setAllProjects(practiceProject);
    //     setMenuToggle({ industrial: false, practice: true })

    // }


    return (
        <div id="project-section" className="container skill">
            <div className="back-line d-flex align-items-center skill-title">
                <div className="front-box d-flex align-items-center">
                    <p className="d-flex align-items-center">Projects</p>
                </div>
            </div>

            {/* <div className="row pb-5">
                <div className="col-12">
                    <button onClick={industrialAction} className={menuToggle.industrial ? "btn btn-lg btn-success my-2 my-sm-0 btn-style" : "btn btn-lg btn-outline-success my-2 my-sm-0 btn-style"}>Industrial Project</button>
                    <button onClick={practiceAction} className={menuToggle.practice ? "btn btn-lg btn-success my-2 my-sm-0 btn-style" : "btn btn-lg btn-outline-success my-2 my-sm-0 btn-style"}>Practice Project</button>
                </div>
            </div> */}
            {/* col-12 col-sm-6 col-md-4 */}
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
                {
                    allProjects.map(project => <Project key={project.id} project={project} ></Project>)
                }
            </div>

        </div>
    );
};

export default Projects;